import type { Room } from "../schema";

// Canonical default for the room's *secondary* Bison contact — the supplier
// onboarding manager who sits below the primary SEM/Sr. Director on the
// Welcome page. Every room shows this by default; the provisioning / update
// skills override it per-deal by setting `room.bisonSecondaryContact`.
//
// Why a constant and not the page-registry: `bisonContact` /
// `bisonSecondaryContact` are room-level fields, and the canonical hydrate
// layer only fills page/widget defaults. This constant is the room-level
// equivalent — the single place the default onboarding contact lives.
//
// photoUrl is a root-relative public asset. The file is dropped into
// `public/` (served from root); until it exists, MUI's Avatar falls back to
// the name initial, so a missing file degrades gracefully rather than
// rendering a broken image.
export const DEFAULT_BISON_SECONDARY_CONTACT: NonNullable<Room["bisonSecondaryContact"]> = {
    name: "Elijah Chang",
    role: "Partner Onboarding",
    email: "elijah.chang@bisoncommerce.com",
    // His 30-minute booking page, so a supplier can book time with him from the
    // Welcome page rail ("Book a time"). Replaced Laura Pakutkaite on 2026-10-27.
    calendlyUrl: "https://calendly.com/elijah-chang/30min",
    photoUrl: "/elijah-chang.jpg",
};
